import { createRouter, createWebHistory } from 'vue-router'

import Home from '../views/Home.vue';
import Management from '../views/Management.vue';
import Touch_Flex from '../views/Touch_Flex.vue';
import Configurator from '../views/Configurator.vue';

const routes = [
    { //Home
        path: '/asd',
        name: 'Home',
        component: Home
    },
    { //Touch_Flex
        path: '/management',
        name: 'Management',
        component: Management
    },
    { //Touch_Flex
        path: '/',
        name: 'Touch_Flex',
        component: Touch_Flex
    },
    { //Configurator
        path: '/configurator/:configuration:/:type:/:hash?/:overlay?',
        name: 'Configurator',
        component: Configurator
    },
]


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router
